import React, { useEffect, useState } from "react";

import Swal from 'sweetalert2'

import { getTokenInfo } from '../../../../UseToken';

import { language } from '../Language';
import {
    reqGET,
    reqPUT,
    reqPOST,
    set_language,
    content_language
} from '../../../../Utils';
import './Confirm.css';

import * as Hosts from '../../../../Hosts';

const Confirm = (props) => {

    const [dados_config, set_dados_config] = useState({});
    const [dados_nl, set_dados_nl] = useState({});
 
	const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    const [show_btn_confirm, set_show_btn_confirm] = useState(false);
    const [is_edit, set_is_edit] = useState(false);

    useEffect(() => { 

        (async () => {
            if(props.item !== undefined && props.item !== null && props.item !== '') {
                if(props.item.dados_config !== undefined && props.item.dados_config !== null && props.item.dados_config !== '') {

                    let nl_id = props.item.dados_config.id
                    let nl_available = props.item.dados_config.info.available
                    
                    set_dados_config(props.item.dados_config)

                    if(nl_available) {
                        set_show_btn_confirm(false)
                    }
                    else {
                        set_show_btn_confirm(true)

                        let res = await reqGET(`${Hosts.SIMCore_API}/web/nl/templates/id/${getTokenInfo().companycode}/${nl_id}`) 
                        if(res.data !== undefined && res.data.length > 0) {
                            console.log('qewe')
                            set_is_edit(true)
                            set_dados_nl(res.data[0])
                        }
                    }

                }
            }
        })()

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }
    
    }, []); 

    const confirm_nl = async () => {
    
        Swal.fire({
            title: language[lang].confirm_title,
            text: language[lang].confirm_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].confirm_confirm,
            cancelButtonText: language[lang].confirm_cancel
        })
        .then(async (result) => {
            if(result.isConfirmed) {

                const nl_interface = {
                    id: '',
                    info: {
                        nl: {
                            id: dados_config.id,
                            uniqid: dados_config.info.uniqid,
                            title: dados_config.info.name
                        },
                        content: '',
                        companycode: dados_config.info.companycode,
                    }
                }
                
                let nl_content = document.getElementById("nl_content")
                nl_interface.info.content = nl_content.innerHTML
                
                console.log('is_edit', is_edit)
                
                if(is_edit) {
                    nl_interface.id = dados_nl.id

                    await reqPUT(`${Hosts.SIMCore_API}/web/nl/templates`, nl_interface)
                }
                else {
                    await reqPOST(`${Hosts.SIMCore_API}/web/nl/templates`, nl_interface)
                }
   
            }
        })
    
    }

  	return (
        show_btn_confirm ?
            <div 
                className="div-confirm text-center border-0 shadow-sm" 
                title={language[lang].content_confirm} 
                target="_blank"
            >
                <button className="btn btn-primary rounded-0" onClick={() => confirm_nl()}>{language[lang].content_confirm}</button>
            </div>
        :
            null
  	);
};

export default Confirm;
